export default {
  convert: async ({ path }: { path: string }) => ({ path, success: true }),
}
